export default __webpack_public_path__ + "static/media/2349.19c92d59.png";